// src/app/formdata-upload/base64-upload.component.ts

import { AfterContentChecked, AfterContentInit, Component, ContentChild, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from '@angular/material';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { Observable } from 'rxjs/Observable';


declare var $: any;

@Component({
	selector: 'base64-upload',
	templateUrl: './base64-upload.component.html'
})
export class Base64UploadComponent implements AfterContentInit {

	public loading: boolean = false;
	public bloquearBoton: boolean = true;
	public mensajes: Array<string> = new Array();
	public displayedColumns;
	public dataSource;
	public erroresTemp: Array<string> = new Array();
	public nombreTabla: string = '';

	public ocultar: boolean= false;
	public mensaje: string="";

	@ViewChild('fileInput') fileInput: ElementRef;
	@ViewChild('form') form;

	constructor(private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar) {
		this.displayedColumns = ['mensaje'];
		this.dataSource = new ExampleDataSource(null);
		this.snackBar.dismiss();
	}

	private formulario: any;


	ngAfterContentInit() {
		$('#archivoLoad').on("change", function () {

			$('#uploadFile').val(
				$('#archivoLoad').val().replace('C:\\fakepath\\', '')
			);
		});
	}

	onFileChange(event) {
		let reader = new FileReader();
		if (event.target.files && event.target.files.length > 0) {
			let file = event.target.files[0];
			reader.readAsDataURL(file);
			reader.onload = () => {
				this.bloquearBoton = false;
				console.log('Recarga');
				this.formulario = {
					nombreArchivo: file.name,
					//filetype: file.type,
					infoArchivo: reader.result.split(',')[1]
				}
			};
		}
	}

	onSubmit() {
		const formModel = this.formulario;
		this.loading = true;
		this.dataSource = new ExampleDataSource(null);
		this.erroresTemp = new Array();


		if (formModel == undefined || formModel.infoArchivo == undefined || formModel.infoArchivo == '') {
			this.openSnackBarEspecial("Hay que seleccionar un archivo", "X");
			this.loading = false;
			return;
		}

		if (this.nombreTabla == null || this.nombreTabla == '' || this.nombreTabla.split(' ').join('') == '') {
			this.openSnackBarEspecial("Hay que escribir el nombre de la tabla", "X");
			this.loading = false;
			return;
		}

		this._serviciosGenerales.post('cargarArchivo/generico/' + this.nombreTabla, formModel).subscribe(
			result => {
				this.formulario = {}

				$("#archivoLoad").val(null);
				$("#uploadFile").val('');

				if (result == undefined || result.errores == undefined || result.errores == null) {
					this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este cargue", "X");
					return;
				}
				console.log(result);
				console.log(result.errores);

				if (result.errores.length == 0) {
					this.openSnackBar("Archivo Cargado correctamente", "X");
				} else {
					this.erroresTemp = new Array();
					this.erroresTemp.push("");
					this.dataSource = new ExampleDataSource(result.errores);
				}


				this.loading = false;

			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este cargue", "X");
				this.loading = false;
				$("#archivoLoad").val(null);
			})

	}


	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }
}



export class ExampleDataSource {

	public data: Array<string>;


	constructor(sucursal: Array<string>) {
		this.data = new Array();


		if (sucursal != null) {
			for (let i of sucursal) {
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<string[]> {
		return Observable.of(this.data);
	}

	disconnect() {
	}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueArchivosGenerico/Base64Upload.component.ts